import { AggregateRoot, CommandHandlerFunction } from "@lookiero/messaging";
import { ImageUploadContext } from "@lookiero/sty-psp-quiz-style-profile-common-ui";
import { UploadImage } from "../command/uploadImage";
import { imageUploaded } from "./imageUploaded";

interface ImagePicker {
  readonly name: string;
  readonly type: string;
  readonly uri: string;
}

type ImagePayload = ImagePicker | Blob;

interface Image extends AggregateRoot {
  readonly styleProfileId: string;
  readonly customerId?: string;
  readonly image?: ImagePayload;
  readonly context?: ImageUploadContext;
}

const uploadImageHandler: CommandHandlerFunction<UploadImage, Image> =
  () =>
  async ({ aggregateRoot, command }) => {
    const { aggregateId, customerId, image, context } = command;

    return {
      ...aggregateRoot,
      customerId,
      image,
      context,
      domainEvents: [imageUploaded({ aggregateId })],
    };
  };

export type { Image, ImagePayload };
export { uploadImageHandler };
